import { useQuery, useMutation} from '@tanstack/react-query'
// import { useNavigate } from 'react-router-dom';
import { 
  isSignInWithEmailLink, 
  signInWithEmailLink,
  GoogleAuthProvider,
  FacebookAuthProvider,
  signInWithPopup,
//   createUserWithEmailAndPassword,
//   signInWithEmailAndPassword
} from 'firebase/auth';
import { auth } from '../auth/firebase';
import {  initiateAuth, verifyUserOTP, getAuthUser, 
    getUserDetails, updateUserDetails, 
    addCommunityMember, getMembership, getMemberAgreement, submitMemberAgreement, 
    addSavedResource, removeSavedResource, createBooking, createMultipleBookings,
    addMembershipCredentials, fetchMemberCredentials, 
    newFeedPost, getFeedPosts, signOut, 
    getUserResourceBookings, getAccountMemberships, getMemberRequirementsStatus, getAccountSubscriptions, 
    updateCommunityMembership, updateResourceBooking, cancelResourceBooking, getUserResourceBookingByUid, getResourceBookings, confirmNewIDPAuthUser } from '../api/crud'
import { 
    AccountSchema, AuthSchema, CredentialSchema, 
    MembershipSchema, SubscriptionSchema, OrderItemSchema, ResourceBookingSchema, 
    FeedPostSchema, AgreementSubmissionSchema 
} from "../data/types";
import { useAuthState } from '../contexts/authcontext'
import { getUIDFromAccessToken, formatIDPUser } from '../utils/helpers';
import { useEffect, useState } from 'react';



const staleTime = 3000
const isEnabled = true


// get user details from access token detail
export const useLoadAuthUser = () => {
    const { userData, updateUserData, updateLogin, updateVerified } = useAuthState()

    const registerUserMutation = useMutation({ 
        mutationFn: async (user: AuthSchema) => {
            console.log("register user")
            const res = await initiateAuth(user)
            return res
    }})

    const verifyUserMutation = useMutation({ 
        mutationFn: async (otp: string) => {
            console.log("verify user")
            if (userData?.username){const res = await verifyUserOTP(otp,userData.username)
            if (res && Object.keys(res).length !== 0 && updateUserData && updateLogin && updateVerified){
                if (res?.login_token && res?.refresh_token){
                    localStorage.setItem('access_token', res.login_token)
                    localStorage.setItem('refresh_token', res.refresh_token)
                }
                updateUserData(res)
                updateLogin(true)
                if (res.auth_status){
                    updateVerified(res.auth_status) 
                    return true
                }
            }}
            return false
    }})

    const registerUser = (user: AuthSchema) => {
        registerUserMutation.mutate(user)
        return registerUserMutation?.data ? true : false
    }

    const verifyUser = (otp: string) => {
        verifyUserMutation.mutate(otp)
        return verifyUserMutation?.data ? true : false
    } 

    const signOutUser = () => {
        console.log("signout")
        signOut()
        if (updateUserData && updateLogin && updateVerified){
            updateUserData({} as AccountSchema)
            updateLogin(false)
            updateVerified(false)
        }
    }


    // // Email/Password Registration
    // const registerWithEmailPassword = async (email: string, password: string) => {
    //     try {
    //         const result = await createUserWithEmailAndPassword(auth, email, password);
    //         const user = result.user;
    //         const accessToken = await user.getIdToken();
    //         localStorage.setItem('accessToken', accessToken);
    //         localStorage.setItem('refreshToken', user.refreshToken);
            
    //         // Call your backend to register the user
    //         const res = await initiateAuth({ email: user.email || '' });
    //         if (res && updateUserData && updateLogin) {
    //             updateUserData(res);
    //             updateLogin(true);
    //         }
    //         return user;
    //     } catch (error) {
    //         console.error('Email/password registration error:', error);
    //         throw error;
    //     }
    // };

    // // Email/Password Sign In
    // const signInWithEmailPassword = async (email: string, password: string) => {
    //     try {
    //         const result = await signInWithEmailAndPassword(auth, email, password);
    //         const user = result.user;
    //         const accessToken = await user.getIdToken();
    //         localStorage.setItem('accessToken', accessToken);
    //         localStorage.setItem('refreshToken', user.refreshToken);
            
    //         // Call your backend to authenticate the user
    //         const res = await initiateAuth({ email: user.email || '' });
    //         if (res && updateUserData && updateLogin) {
    //             updateUserData(res);
    //             updateLogin(true);
    //         }
    //         return user;
    //     } catch (error) {
    //         console.error('Email/password sign-in error:', error);
    //         throw error;
    //     }
    // };
    
    const isLoading = (
        // loadAuthMutation.isPending || 
        registerUserMutation.isPending ||  
        verifyUserMutation.isPending
    );

    return { 
        registerUser, 
        verifyUser, 
        signOutUser, 
        // registerWithEmailPassword,
        // signInWithEmailPassword,
        isLoading 
    }
}




export const useGetAuthUser = (tokenUid: string) => {
    // const { authUser, updateAuthUser, updateLogin, updateVerified } = useAuthState()
    // console.log("tokenUid", tokenUid)

    const {data: authUser, refetch: reloadAuthUser,  isLoading: isLoadingAuthUser} = useQuery({ 
        queryKey: ['authUser', tokenUid], 
        queryFn: async () => {
            if (tokenUid){
                console.log("get auth token user")
                const res = await getAuthUser({token_uid: tokenUid})
                return res
            }
            return null
        },
        staleTime,
        enabled: isEnabled
    })
    return {authUser, isLoadingAuthUser, reloadAuthUser}
}


export const useLoadUserDetails = (uid: string) => {
    const { updateUserData, updateLogin } = useAuthState()

    const {data: user, refetch: reloadUser, isLoading: isLoadingUser, isFetching: isFetchingUser} = useQuery({ 
        queryKey: ['user', uid], 
        queryFn: async () => {
            try {
                console.log("get user details")
                const res = await getUserDetails(uid)
                if (res && updateUserData !== undefined && updateLogin !== undefined){
                    updateUserData(res)
                    updateLogin(true)
                }
                return res
            } catch (e) {
                console.error(e)
                return null
            }
        },
        staleTime,
        enabled: isEnabled
    })
    return {user, isLoadingUser, isFetchingUser, reloadUser}
}


export const useCompleteSignIn = () => {
    // const navigate = useNavigate();

    const completeSignInWithEmailLink = async (email: string, currentURL: string) => {
        if (isSignInWithEmailLink(auth, currentURL)) {
            try {
              const result = await signInWithEmailLink(auth, email!, currentURL);
              const user = result.user
              console.log('Successfully signed in user');
              const accessToken = await user?.getIdToken()
              localStorage.setItem('accessToken', accessToken)
              localStorage.setItem('refreshToken', user?.refreshToken)
              localStorage.removeItem('login_token');
            //   localStorage.removeItem('currentPageUrl');
              localStorage.removeItem('lastPagePath');
              // TODO: get / replace access & refresh token, and convert to object, sample;
              // add user to context & update isSignedIn context & navigate to home
            //   const data = useLoadUserDetails(getEmailFromAccessToken(localStorage.getItem('accessToken')))
            //   navigate('/');
              // You can redirect to another page or perform additional actions here
              return user
            } catch (e: any) {
              // setError(error.message);
              // error = `Error signing in with email link: ${e}`
              // error = e
              console.error(e);
              return null
            }
        }
    }

    const signOut = () => {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('login_token');
      }

    // const completeSignInWithEmailLink = (email: string) => {
    //     return signInUser(email)
    // }

    const userDetails = useLoadUserDetails(getUIDFromAccessToken(localStorage.getItem('accessToken')))

    const googleSignInMutation = useMutation({ 
        mutationFn: async () => {
            console.log("google sign in")
            try {
                const provider = new GoogleAuthProvider();
                const result = await signInWithPopup(auth, provider);
                const user = result.user;
                // console.log("google sign in user", user)
                // Calling backend to register/authenticate the user
                if (user){
                    const accessToken = await user.getIdToken();
                    localStorage.setItem('accessToken', accessToken);
                    localStorage.setItem('refreshToken', user.refreshToken);
    
                    const res = await confirmNewIDPAuthUser(formatIDPUser(user));
                    // console.log("google sign in response", res)
                    if (res){
                        userDetails.reloadUser()
                        return res;
                    }
                }
            } catch (error) {
                console.error('Google sign-in error:', error);
            }
    
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
            return null;
    }})

    // Google Authentication
    const signInWithGoogle = async () => {
        googleSignInMutation.mutate()
        return googleSignInMutation?.data
    };

    const facebookSignInMutation = useMutation({ 
        mutationFn: async () => {
            console.log("facebook sign in")
            try {
                const provider = new FacebookAuthProvider();
                const result = await signInWithPopup(auth, provider);
                const user = result.user;
                // console.log("facebook sign in user", user)            
                // // Calling backend to register/authenticate the user
                if (user){
                    const accessToken = await user.getIdToken();
                    localStorage.setItem('accessToken', accessToken);
                    localStorage.setItem('refreshToken', user.refreshToken);
    
                    const res = await confirmNewIDPAuthUser(formatIDPUser(user));
                    // console.log("facebook sign in response", res)
                    if (res){
                        userDetails.reloadUser()
                        return res;
                    }
                }
            } catch (error) {
                console.error('Facebook sign-in error:', error);
            }
    
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
            return null;
    }})


    // Facebook Authentication
    const signInWithFacebook = async () => {
        facebookSignInMutation.mutate()
        return facebookSignInMutation?.data
    };

    const getSavedResourceTruths = () => {
        if (userDetails && userDetails?.user && userDetails?.user?.saved_resources){
            const savedResources = userDetails.user.saved_resources
            const newObject = savedResources.reduce((acc, item) => {
                if (item && item?.id){
                    acc[item.id] = true
                }
                return acc;
            }, {} as Record<string, boolean>);
            return newObject
        }
        return {} as Record<string, boolean>
    }

    // const [cartItems, updateCartItems] = useState<OrderItemSchema[]>((userDetails && userDetails?.user?.cart_items) ? userDetails?.user?.cart_items : [])

    const [cartItems, updateCartItems] = useState<{[key: string]: OrderItemSchema[]}>(() => {
        const storedCart = localStorage.getItem('cart');
        return (userDetails && userDetails?.user?.cart_items) ? userDetails?.user?.cart_items : (storedCart ? JSON.parse(storedCart) : []);
    });

    const updateCart = (resourceId: string, newItem: OrderItemSchema, quantity: number = 0) => {
        resourceId = resourceId || "";
        if (newItem?.item_name && resourceId) {
            var cartList: OrderItemSchema[] = cartItems[resourceId] || [];
            const itemIndex = cartList.findIndex(i => i.item_name === newItem.item_name);
    
            if (itemIndex >= 0 && quantity !== newItem.total_quantity) {
                newItem.total_quantity = quantity;
                if (quantity === 0) {
                    cartList = cartList.filter(i => i.item_name !== newItem.item_name);
                } else {
                    cartList[itemIndex] = newItem;
                }
                
                updateCartItems(prev => ({...prev, [resourceId]: cartList}));
            } else {
                updateCartItems(prev => ({
                    ...prev,
                    [resourceId]: [...(prev[resourceId] || []), newItem]
                }));
            }
        }
    };

    const clearCart = () => {
        localStorage.removeItem('cart')
        updateCartItems({});
    }

    // const clearResourceCart = (resourceId: string) => {
    //     var storedCart = localStorage.getItem('cart');
    //     storedCart = storedCart ? JSON.parse(storedCart) : []
    //     // if (storedCart && storedCart[resourceId]){
    //     // localStorage.removeItem('cart')
    //     // updateCartItems({});
    // }

    useEffect(() => {
        localStorage.setItem('cart', JSON.stringify(cartItems));
    }, [cartItems]);

    return {
        completeSignInWithEmailLink, 
        signInWithGoogle, 
        signInWithFacebook,
        user: userDetails.user, 
        cartItems, 
        updateCart, 
        clearCart, 
        isLoadingUser: userDetails.isLoadingUser,
        isFetchingUser: userDetails.isFetchingUser,
        isLoading: userDetails.isLoadingUser || userDetails.isFetchingUser || googleSignInMutation.isPending || facebookSignInMutation.isPending, 
        reloadUser: userDetails.reloadUser, 
        getSavedResourceTruths, 
        signOut
    }
  };


  export const useUpdateAccountDetails = (uid: string) => {

    const { reloadUser } = useLoadUserDetails(uid)
    
    const updateAccountMutation = useMutation({ 
        mutationFn: async (updateData: AccountSchema) => {
            console.log("update account")
            const res = await updateUserDetails(uid, updateData)
            if (!res) {
                throw new Error('Failed to update account')
            }
            await reloadUser()
            return res
    }})

    /** Updates account details; resolves on success and rejects on failure */
    const updateAccount = async (accountUpdate: AccountSchema) => {
        return updateAccountMutation.mutateAsync(accountUpdate)
    }


    const saveResourceMutation = useMutation({ 
        mutationFn: async (resourceId: string) => {
            console.log("add saved resource")
            const res = await addSavedResource(uid, resourceId)
            return res
        },
        onSuccess: async () => {
            await reloadUser()
        }
    })

    const saveResource = (resourceId: string) => {
        saveResourceMutation.mutate(resourceId)
        return saveResourceMutation?.isSuccess
    }


    const removeResourceMutation = useMutation({ 
        mutationFn: async (resourceId: string) => {
            console.log("remove saved resource")
            const res = await removeSavedResource(uid, resourceId)
            return res
        },
        onSuccess: async () => {
            await reloadUser()
        }
    })

    const removeResource = async (resourceId: string) => {
        const res = await removeResourceMutation.mutateAsync(resourceId)
        return res
    }


    const isLoading = (
            updateAccountMutation.isPending ||
            saveResourceMutation.isPending || 
            removeResourceMutation.isPending
    )
    return { updateAccount, saveResource, removeResource, isLoading }
}



export const useAddCredential = (uid: string) => {
    type mutationProps = {
        communityId: string
        credential: CredentialSchema
    }
    const { reloadRequirementsMet, isLoadingRequirementsMet } = useGetMemberRequirementsStatus(uid)
    const mutation = useMutation({ 
            mutationFn: async ({communityId, credential}: mutationProps) => {
            console.log("add member credentials")
            const res = await addMembershipCredentials(uid, communityId, credential)
            await reloadRequirementsMet()
            return res
    }})

    const addMemberCredential = (communityId: string, credential: CredentialSchema) => {
        mutation.mutate({communityId, credential})
        return mutation?.data ? true : false
    }

    const isLoadingCredential = mutation.isPending || isLoadingRequirementsMet
    const isAddCredentialSuccess = mutation.isSuccess
    const isAddCredentialError = mutation.isError
    const isAddCredentialIdle = mutation.isIdle
    return { addMemberCredential, isLoadingCredential, isAddCredentialSuccess, isAddCredentialError, isAddCredentialIdle } 
}


export const useGetCredentials = (memberUid: string, communityId?: string) => {
    const {data: memberCredentials, refetch: reloadCredentials, isLoading: isLoadingCredentials} = useQuery({ 
        queryKey: ['credentials', memberUid], 
        queryFn: async () => {
            console.log("fetching credentials")
            const res = await fetchMemberCredentials(memberUid, communityId)
            return res
        },
        staleTime,
        enabled: isEnabled
    })

    return { isLoadingCredentials, memberCredentials, reloadCredentials}
}


/** Fetches the saved member agreement for a community (returns object with presigned url for .docx). */
export const useGetCommunityMemberAgreement = (communityId: string) => {
    const {
        data: agreement, isLoading: agreementLoading, isError: IsAgreementError, error: AgreementError, refetch: reloadAgreement
    } = useQuery({
        queryKey: ['agreement', communityId],
        queryFn: async () => { const res = await getMemberAgreement(communityId); return res; },
    });

    // const addMemberAgreementMutation = useMutation({
    //     mutationFn: async (agreement: CommunityAgreementSchema) => {
    //         return await addMemberAgreement(communityId as string, agreement)
    //     }
    // })

    // const addMemberAgreementData = async (agreement: CommunityAgreementSchema) => {
    //     const result = await addMemberAgreementMutation.mutateAsync(agreement);
    //     return result ? true : false;
    // }

    return { agreement, agreementLoading, IsAgreementError, AgreementError, reloadAgreement };
}

/** Fetches the saved member agreement for a community (returns object with presigned url for .docx). */
export const useSubmitMemberAgreement = (uid: string, communityId: string) => {
    const { reloadCurrentMember } = useLoadMember(communityId)
    const agreementSubmissionMutation = useMutation({
        mutationFn: async (memberInfo: AgreementSubmissionSchema) => {
            const res = await submitMemberAgreement(uid, communityId as string, memberInfo)
            return res as MembershipSchema | null
        },
        onSuccess: () => {
            reloadCurrentMember()
        }
    });

    const submitAgreement = (memberInfo: AgreementSubmissionSchema): Promise<MembershipSchema | null> => {
        return agreementSubmissionMutation.mutateAsync(memberInfo) as Promise<MembershipSchema | null>
    }

    const isLoadingSubmittedAgreement = agreementSubmissionMutation.isPending
    const isErrorSubmittedAgreement = agreementSubmissionMutation.isError
    const errorSubmittedAgreement = agreementSubmissionMutation.error
    return { submitAgreement, isLoadingSubmittedAgreement, isErrorSubmittedAgreement, errorSubmittedAgreement }
}

export const useAddMembership = (memberUid: string, communityId: string) => {

    const mutation = useMutation({ 
        mutationFn: async (membership: MembershipSchema) => {
            console.log("add member")
            const res = await addCommunityMember(memberUid, communityId, membership)
            // if (res && Object.keys(res).length !== 0 ){
            //     if (res?.login_token && res?.refresh_token){
            //         localStorage.setItem('access_token', res.login_token)
            //         localStorage.setItem('refresh_token', res.refresh_token)
            //     }
            //     // updateAuthUser(res)
            //     // updateLogin(true)
            //     // if (res.auth_status){
            //     //     updateVerified(res.auth_status) 
            //     // }
            // }
            // await reloadMemberships()
            // await reloadRequests()
            return res
    }})

    const addMembership = (membershipUpdate: MembershipSchema) => {
        mutation.mutate(membershipUpdate) 
        return mutation.isSuccess
    }

    const isLoadingMembership = mutation.isPending
    const isAddMembershipError = mutation.isError
    const isAddMembershipIdle = mutation.isIdle
    const isAddMembershipSuccess = mutation.isSuccess
    return { addMembership, isLoadingMembership, isAddMembershipSuccess, isAddMembershipError, isAddMembershipIdle }
}

export const useLoadMember = (communityId: string) => {
    let { user } = useCompleteSignIn()
    const uid = user?.uid ? user.uid : ""
    const {data: currentMember, isLoading: isLoadingCurrentMember, refetch: reloadCurrentMember} = useQuery({ 
        queryKey: ['currentMember', communityId, uid], 
        queryFn: async () => {
            console.log("fetching membership by username")
            const res = await getMembership(communityId, uid)
            return res
        }
    })
    return {isLoadingCurrentMember, currentMember, reloadCurrentMember}
}


export const useLoadAccountMemberships = (uid: string) => {
    const {
        data: accountMemberships,
        isLoading: isLoadingAccountMemberships,
        isFetching: isFetchingAccountMemberships,
        refetch: reloadAccountMemberships,
    } = useQuery({
        queryKey: ['accountMemberships', uid],
        queryFn: async () => {
            console.log("fetching account memberships")
            const res = await getAccountMemberships(uid)
            return res
        },
        enabled: !!uid,
    })
    return {
        isLoadingAccountMemberships,
        isFetchingAccountMemberships,
        accountMemberships,
        reloadAccountMemberships,
    }
}


export const useLoadAccountSubscriptions = (uid: string) => {
    const {
        data: accountSubscriptions,
        isLoading: isLoadingAccountSubscriptions,
        isFetching: isFetchingAccountSubscriptions,
        refetch: reloadAccountSubscriptions,
    } = useQuery<SubscriptionSchema[] | null>({
        queryKey: ['accountSubscriptions', uid],
        queryFn: async () => {
            const res = await getAccountSubscriptions(uid)
            return res ?? []
        },
        enabled: !!uid,
    })
    return {
        isLoadingAccountSubscriptions,
        isFetchingAccountSubscriptions,
        accountSubscriptions,
        reloadAccountSubscriptions,
    }
}


export const useUpdateMembership = (communityId: string) => {
    let { user } = useCompleteSignIn()
    const uid = user?.uid ? user.uid : ""
    const { reloadCurrentMember } = useLoadMember(communityId)

    const mutation = useMutation({ 
        mutationFn: async (updateData: MembershipSchema) => {
            console.log("update member")
            const res = await updateCommunityMembership(communityId, uid, updateData)
            console.log("update member res", res)
            reloadCurrentMember()
            return res
    }})

    const updateMembership = (membershipUpdate: MembershipSchema) => {
        mutation.mutate(membershipUpdate)
        return mutation?.isSuccess
    }

    const isLoadingMembership = mutation.isPending
    return { updateMembership, isLoadingMembership }
}


// export const useFetchRequirementsLookUp = (communityRequirements: RequirementSchema[], memberCredentials: CredentialSchema[], paymentMethods: any[]) => {
//     const {data, refetch: reloadRequirementsMet, isLoading: isLoadingRequirementsMet} = useQuery({ 
//         queryKey: ['requirementsMet', memberCredentials, paymentMethods], 
//         queryFn: async () => {
//             console.log("fetching requirements met")
//             const res = await fetchRequirementsLookUp(memberCredentials, paymentMethods)
//             // const res = await fetchRequirementsMet(communityRequirements, memberCredentials, paymentMethods)
//             return res
//         }
//     })
//     const membershipRequirementsStatus = data ? data as CurrentRequirementsSchema[] : []
//     return {communityRequirements, membershipRequirementsStatus, reloadRequirementsMet, isLoadingRequirementsMet}
// }

export const useGetMemberRequirementsStatus = (uid: string) => {
    const {data, refetch: reloadRequirementsMet, isLoading: isLoadingRequirementsMet} = useQuery({ 
        queryKey: ['MemberRequirementsStatus', uid], 
        queryFn: async () => {
            console.log("fetching memberRequirements statuses")
            const res = await getMemberRequirementsStatus(uid)
            return res
        },
        staleTime
    })
    const memberRequirementStatuses = data ? data : {}
    return {memberRequirementStatuses, reloadRequirementsMet, isLoadingRequirementsMet}
}


export const useAddBooking = (uid: string) => {
    const { reloadBookings } = useLoadBookings(uid)
    const mutation = useMutation({ 
        mutationFn: async (booking: ResourceBookingSchema) => {
            // console.log("add booking", booking) 
            const res = await createBooking(uid, booking)
            return res
        },
        onSuccess: async () => {
            console.log("add booking success")
            await reloadBookings()
        }
    })

    const addNewBooking = async (bookingData: ResourceBookingSchema) => {
        const res = await mutation.mutateAsync(bookingData)
        return res ? true : false
    }

    const isLoadingBooking = mutation.isPending
    const isAddBookingSuccess = mutation.isSuccess
    const isAddBookingError = mutation.isError
    return { addNewBooking, isLoadingBooking, isAddBookingSuccess, isAddBookingError }
}


export const useAddMultipleBookings = (uid: string) => {
    const { reloadBookings } = useLoadBookings(uid)
    const mutation = useMutation({ 
        mutationFn: async ({resource_id, bookings}: {resource_id: string, bookings: ResourceBookingSchema[]}) => {
            const res = await createMultipleBookings(uid, resource_id, bookings)
            return res
        },
        onSuccess: async () => {
            console.log("add multiple bookings success")
            await reloadBookings()
        }
    })
 
    const addMultipleBookings = async ({resource_id, bookings}: {resource_id: string, bookings: ResourceBookingSchema[]}) => {
        const res = await mutation.mutateAsync({resource_id, bookings})
        return res ? true : false
    }

    const isLoadingMultipleBookings = mutation.isPending
    const isAddMultipleBookingsSuccess = mutation.isSuccess
    const isAddMultipleBookingsError = mutation.isError

    return { addMultipleBookings, isLoadingMultipleBookings, isAddMultipleBookingsSuccess, isAddMultipleBookingsError }
}
// export const useUpdateBooking = (communityId: string, bookingId: string) => {
//     const mutation = useMutation({ 
//         mutationFn: async (bookingUpdate: ResourceBookingSchema) => {
//             const res = await updateResourceBooking(communityId, bookingId, bookingUpdate)
//             return res
//     }})

//     const updateBooking = (bookingUpdate: ResourceBookingSchema) => {
//         mutation.mutate(bookingUpdate)
//         return mutation?.data ? true : false
//     }

//     const isLoadingBooking = mutation.isPending
//     const isUpdateBookingSuccess = mutation.isSuccess
//     const isUpdateBookingError = mutation.isError
//     return { updateBooking, isLoadingBooking, isUpdateBookingSuccess, isUpdateBookingError }
// }

export const useFeedPosts = () => {
    const { data: feedPosts, isLoading: isLoadingFeedPosts, isFetching: isFetchingFeedPosts, isError, refetch:reloadFeedPosts } = useQuery({
        queryKey: ['feedPosts'], 
        queryFn: async () => {
            console.log("Getting feed posts");
            const response = await getFeedPosts(); 
            return response;
        },
        staleTime,
        enabled: isEnabled
    });
    return { feedPosts, isLoadingFeedPosts, isFetchingFeedPosts, isError, reloadFeedPosts };
}

export const useAddPost = (uid: string) => {
    const { reloadFeedPosts } = useFeedPosts()
    const mutation = useMutation({ 
        mutationFn: async (post: FeedPostSchema) => {
            console.log("add post") 
            const res = await newFeedPost(uid, post)
            reloadFeedPosts()
            return res
    }})

    const addNewPost = (post: FeedPostSchema) => {
        mutation.mutate(post)
        return mutation?.data ? true : false
    }

    const isLoadingPost = mutation.isPending
    const isAddPostSuccess = mutation.isSuccess
    const isAddPostError = mutation.isError
    return { addNewPost, isLoadingPost, isAddPostSuccess, isAddPostError }
}

export const useLoadBookings = (uid: string) => {
    const {data: bookings, refetch: reloadBookings, isLoading: isLoadingBookings} = useQuery({ 
        queryKey: ['bookings', uid], 
        queryFn: async () => {
            console.log("fetching bookings")
            const res = await getUserResourceBookings(uid)
            return res
        },
        staleTime,
        enabled: isEnabled
    })

    const updateBookingMutation = useMutation({ 
        mutationFn: async ({communityId, bookingId, changedAttributes}: {communityId: string, bookingId: string, changedAttributes: ResourceBookingSchema}) => {
            const res = await updateResourceBooking(communityId, bookingId, changedAttributes)
            reloadBookings()
            return res
    }})

    const updateBooking = (communityId: string, bookingId: string, changedAttributes: ResourceBookingSchema) => {
        updateBookingMutation.mutate({communityId, bookingId, changedAttributes})
        return updateBookingMutation?.data ? true : false
    }

    const cancelBookingMutation = useMutation({ 
        mutationFn: async ({communityId, resourceId, bookingId}: {communityId: string, resourceId: string, bookingId: string}) => {
            const res = await cancelResourceBooking(communityId, resourceId, bookingId)
            return res
        },
        onSuccess: async () => {
            console.log("cancel booking success")
            await reloadBookings()
        }
    })

    const cancelBooking = async (communityId: string, resourceId: string, bookingId: string) => {
        const res = await cancelBookingMutation.mutateAsync({communityId, resourceId, bookingId})
        return res
    }

    const isLoading = isLoadingBookings || updateBookingMutation.isPending || cancelBookingMutation.isPending
    const isUpdateBookingSuccess = updateBookingMutation.isSuccess
    const isUpdateBookingError = updateBookingMutation.isError
    const isCancelBookingSuccess = cancelBookingMutation.isSuccess
    const isCancelBookingError = cancelBookingMutation.isError
    return { isLoading, bookings, isUpdateBookingSuccess, isUpdateBookingError, isCancelBookingSuccess, isCancelBookingError, reloadBookings, updateBooking, cancelBooking }
}


export const useLoadResourceBookings = (communityId: string, resourceId: string) => {                       
    const {data: resourceBookings, refetch: reloadResourceBookings, isLoading: isLoadingResourceBookings} = useQuery({ 
        queryKey: ['resourceBookings', communityId, resourceId], 
        queryFn: async () => {
            console.log("fetching resource bookings")
            const res = await getResourceBookings(communityId, resourceId)
            return res
        }
    })

    return { isLoadingResourceBookings, resourceBookings, reloadResourceBookings }
}

export const useLoadUserResourceBooking = (communityId: string, resourceId: string, uid: string) => {                       
    const {data: userResourceBooking, refetch: reloadUserResourceBooking, isLoading: isLoadingUserResourceBooking} = useQuery({ 
        queryKey: ['userResourceBooking', communityId, resourceId, uid], 
        queryFn: async () => {
            console.log("fetching user resource booking")
            const res = await getUserResourceBookingByUid(communityId, resourceId, uid)
            return res
        },
        staleTime,
        enabled: isEnabled
    })

    return { isLoadingUserResourceBooking, userResourceBooking, reloadUserResourceBooking }
}
// const handleSetBrowserSession = (sessionId: string) => {
//     const newSessionId = generateUUID();
//     localStorage.setItem('sessionId', newSessionId)
// }




